import { digitsEnToFa } from '@persian-tools/persian-tools';
import moment from 'jalali-moment';

export interface ReleaseAtLabel {
  /** «شنبه ۲ آبان» — weekday first: release days are remembered by weekday («شنبه‌ها ساعت ۸»). */
  day: string;
  /** «شنبه» alone, for tight spots. */
  weekday: string;
  /** «۰۸:۰۰» */
  clock: string;
  /** «امروز» / «فردا» / «۳ روز دیگر» — how far away it is, for the chip beside it. */
  relative: string;
}

/**
 * Formats the next release of new appointments (Saman `nearest_available_time`, i.e. the product's
 * `next_release_at`) for the full-capacity card and the Jabaz widget. `null` for a missing or past time.
 */
export const formatReleaseAt = (iso?: string | null, now: Date = new Date()): ReleaseAtLabel | null => {
  if (!iso) return null;
  const at = moment(iso);
  if (!at.isValid() || at.valueOf() <= now.getTime()) return null;

  const days = at.clone().startOf('day').diff(moment(now).startOf('day'), 'days');
  return {
    day: digitsEnToFa(at.clone().locale('fa').format('dddd jD jMMMM')),
    weekday: at.clone().locale('fa').format('dddd'),
    clock: digitsEnToFa(at.format('HH:mm')),
    relative: days <= 0 ? 'امروز' : days === 1 ? 'فردا' : `${digitsEnToFa(days)} روز دیگر`,
  };
};
